import { Component } from '@angular/core';
import { Flowchart } from "../flowchart/flowchart";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
  selector: 'app-flowchart-spinner',
  imports: [Flowchart, MatProgressSpinner],
  templateUrl: './flowchart-spinner.html',
  styleUrl: './flowchart-spinner.scss',
})
export class FlowchartSpinner {
  protected isLoading = true


  traceComplete():void {
    console.log("Complete bien reçu")
    setTimeout(() => {
      this.isLoading = false
    }, 0)

  }

}
